<template>
  <CRow>
    <CCol col="12" xl="12">
      <!-- <transition name="slide"> -->
      <CCard>
        <CCardHeader>
          Customer Search
        </CCardHeader>
        <CCardBody>
          <div style="width:100%;float:left;text-align: center;padding-bottom:15px;">
            <!-- <label style="width:100%;text-align:center;color:#ccc;">Press Esc to clear search</label> -->
            <select style="width:250px;margin-left:auto;margin-right:auto;margin-bottom:15px;" v-model="filter" class="form-control" @change="searchCustomer()">
              <option value="Search Customer">Search Customer</option>
              <option value="Show Credit Holds">Show Credit Holds</option>
              <option value="Pull Customer From NetSuite">Pull Customer From NetSuite</option>
            </select>
            <div style="width:320px;text-align:center;margin-left:auto;margin-right:auto;" v-if="filter === 'Search Customer' || filter === 'Pull Customer From NetSuite'">
              <input type="search" placeholder="Search Customer Number" class="form-control float-left searchInput" @keyup.enter="searchCustomer()" style="width:250px;" v-model="searchValue" />
              <CButton size="sm" color="info" class="searchButton" @click="searchCustomer()">{{filter === 'Search Customer' ? 'Search' : 'Pull Cust'}}</CButton>
            </div>
          </div>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader>
          Customers
          <CButton size="sm" style="float:right;" color="success" @click="addModal = true">Add Customer</CButton>
        </CCardHeader>
        <CCardBody>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CDataTable
            :items="items"
            :fields="fields"
            column-filter
            table-filter
            :items-per-page="100"
            pagination
            v-if="items && !searchLoading"
          >
          <template #on_hold="{item}">
            <td>
              {{ item.on_hold ? 'Yes' : 'No' }}
            </td>
          </template>
          <template #edit="{item}">
            <td>
              <CButton size="sm" color="primary" @click="edit( item )">Edit</CButton>
            </td>
          </template>
          <!-- <template #delete="{item}">
            <td>
              <CButton size="sm" v-if="you!=item.id" color="danger" @click="deleteUser( item.id )">Delete</CButton>
            </td>
          </template> -->
        </CDataTable>
        <small-loader v-else-if="searchLoading"></small-loader>
        <span v-else>Search Customer...</span>
        </CCardBody>
      </CCard>
      <!-- </transition> -->

      <CModal
        title="Add Style"
        :show.sync="addModal"
      >
        <CForm>
          <CInput
            :lazy="false"
            :value.sync="form.customer_name"
            placeholder="Customer Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="form.customer_number"
            placeholder="Customer Number"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            :value.sync="form.rep_number"
            placeholder="Rep Number"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
        </CForm>
        <template #footer>
          <CButton @click="addModal = false, reset()" color="danger">Cancel</CButton>
          <CButton @click="add()" color="success">Add</CButton>
        </template>
      </CModal>

      <CModal
        title="Edit Color"
        :show.sync="editModal"
      >
        <CForm v-if="editForm">
          <CInput
            :lazy="false"
            label="Customer Name"
            :value.sync="editForm.customer_name"
            placeholder="Customer Name"
            autocomplete="given-name"
            disabled
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Customer Number"
            :value.sync="editForm.customer_number"
            placeholder="Customer Number"
            autocomplete="given-name"
            disabled
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Rep Number"
            :value.sync="editForm.rep_number"
            placeholder="Rep Number"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Internal ID"
            :value.sync="editForm.internal_id"
            placeholder="Netsuite Internal ID"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div class="float-left col-sm-12 p-0">
            <label>Allowed Imperial Belts</label>
            <select class="form-control" v-model="editForm.allowed_imperial_belts">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
          <div class="float-left col-sm-12 mt-3 p-0">
            <label>Disabled?</label>
            <div>
              <CButton size="sm" @click="editForm.disabled = 1" :color="editForm.disabled === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="editForm.disabled = 0" style="margin-left:5px;" :color="editForm.disabled === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
        </CForm>
        <template #footer>
          <CButton @click="editModal = false, resetEdit()" color="danger">Cancel</CButton>
          <CButton @click="save()" color="success">Save</CButton>
        </template>
      </CModal>
    </CCol>
  </CRow>
</template>

<script>
var methods = {}

methods.searchCustomer = function () {
  this.searchLoading = true
  this.items = ''
  const postData = {
    customer_number: this.searchValue,
    filter: this.filter
  }
  if (this.filter === 'Show Credit Holds' || this.searchValue) {
    var self = this
    axios.post( this.$apiAdress + '/api/searchAdminCustomers?token=' + localStorage.getItem("api_token"), postData)
    .then(function (response) {
      console.log(response)
      if (self.filter === 'Customer Search') {
        self.items = [response.data]
      } else {
        self.items = response.data
      }
      self.searchLoading = false
    }).catch(function (error) {
      console.log(error)
    });
  } else {
    this.searchLoading = false
    this.items = ''
  }
}

methods.getData = function () {
  let self = this
  axios.post( this.$apiAdress + '/api/getAdminCustomers?token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    self.items = response.data
  }).catch(function (error) {
    console.log(error)
  });
}

methods.reset = function () {
  this.form = {customer_name: '', customer_number: '', rep_number: '', internal_id: ''}
}

methods.resetEdit = function () {
  this.editModal = null
}

// methods.edit = function (val) {
//   // this.$router.push({ path: '/styles/' + val + '/edit' })
//   this.editForm = val
//   this.editModal = true
// }

methods.edit = function (val) {
  // Assuming val contains the customer ID as 'id'
  this.editForm = {
    ...val, // Copy all properties from val
  };
  this.editModal = true;
}

methods.save = function () {
  let self = this
  axios.post(this.$apiAdress + '/api/customer/update?token=' + localStorage.getItem('api_token'), self.editForm)
  .then(function (response) {
    self.editForm = null
    self.editModal = false
  }).catch(function (error) {
    console.log(error)
  })
}

methods.add = function () {
  let self = this;
  axios.post(   this.$apiAdress + '/api/customer/store?token=' + localStorage.getItem("api_token"),
    self.form
  )
  .then(function (response) {
      console.log(response)
      self.items.push(response.data)
      self.form = self.getForm()
      self.addModal = false
  }).catch(function (error) {
      // if(error.response.data.message == 'The given data was invalid.'){
      //   self.message = '';
      //   for (let key in error.response.data.errors) {
      //     if (error.response.data.errors.hasOwnProperty(key)) {
      //       self.message += error.response.data.errors[key][0] + '  ';
      //     }
      //   }
      //   self.showAlert();
      // }
  });
}

methods.getForm = function () {
  return {
    customer_name: '',
    customer_number: '',
    rep_number: '',
    internal_id: ''
  }
}

export default {
  name: 'AdminCustomersTable',
  data() {
    return {
      items: '',
      fields: ['customer_name', 'customer_number', 'rep_number', 'on_hold', 'edit'],
      currentPage: 1,
      perPage: 5,
      filter: 'Search Customer',
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      addModal: false,
      form: this.getForm(),
      editForm: null,
      editModal: false,
      searchValue: '',
      searchLoading: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  methods: methods,
  mounted: function(){
    // this.getData()
  }
}
</script>
